import React, { useEffect, useState } from "react";
import { Spinner } from "reactstrap";
import { AvForm, AvField } from "availity-reactstrap-validation";
import { useStore1Selector } from "./../../../index";
import { loginUser } from "../../../Redux/Slices/userSlice";
import usePost from "../../../hooks/usePost";

function UnitNotice({ closeModal, unitID, reFetchNotice }) {
  const userDet = useStore1Selector(loginUser);
  const token = userDet?.token;
  const { execute, pending, data: postData } = usePost();
  const [noticeDocument, setNoticeDocument] = useState();

  const handleValidSubmit = (e, v) => {
    e.preventDefault();
    const Method = "POST",
      endPoint = `notices/unit/${unitID}`,
      isJSON = true;

    const formdata = new FormData();
    formdata.append("subject", v.title);
    formdata.append("description", v.notice);
    if (noticeDocument) {
      formdata.append("noticeDocument", noticeDocument);
    }
    execute(
      endPoint,
      formdata,
      Method,
      "Notice successfully sent",
      token,
      isJSON
    );
    closeModal(false);
    setTimeout(() => {
      reFetchNotice();
    }, 2000);
  };

  const onFileChange = (e) => {
    setNoticeDocument(e.target.files[0]);
  };

  return (
    <div>
      <AvForm
        className="form-horizontal mt-4"
        onValidSubmit={(e, v) => {
          handleValidSubmit(e, v);
        }}
      >
        <div className="mb-3">
          <AvField
            name="title"
            label="Subject"
            className="form-control"
            type="select"
            required
          >
            <option> Select... </option>
            <option value="Rent"> Rent </option>
            <option value="Maintenance"> Maintenance </option>
            <option value="Vacate"> Vacate </option>
            <option value="Warning"> Warning </option>
            <option value="Others"> Others </option>
          </AvField>
        </div>

        <div className="mb-3">
          <AvField
            name="name"
            label="Attachment (Optional)"
            type="file"
            className="form-control"
            onChange={onFileChange}
          />
        </div>

        <div className="mb-3">
          <AvField
            className="form-control"
            type="textarea"
            label="Message"
            rows="3"
            name="notice"
            errorMessage="This value is required."
            validate={{ required: { value: true } }}
          />
        </div>

        <button
          className="btn login-btn w-md waves-effect waves-light"
          type="submit"
        >
          {!pending ? <span className="me-2"> Submit </span> : null}
          {!pending ? null : (
            <span>
              <Spinner
                as="span"
                animation="border"
                size="sm"
                className="me-2"
              />
              Loading...
            </span>
          )}
        </button>
      </AvForm>
    </div>
  );
}

export default UnitNotice;
